<main>
  <app-hero></app-hero>
  <app-home-directory></app-home-directory>
</main>